import React from 'react';

import { Spinner } from '@/components/Spinner';
import { useRequiredParams } from 'utils';

import { HouseholdOverviewHeader } from './components/HouseholdOverviewHeader';
import { PortfolioList } from './components/PortfolioList';
import { useHouseholdOverview } from './hooks/useHouseholdOverview';

export const HouseholdOverviewTab = () => {
    const { globalAccountGUID } = useRequiredParams(['globalAccountGUID']);
    const { accountData, accountGroupProfiles, isLoading } = useHouseholdOverview(globalAccountGUID);

    if (isLoading) {
        return (
            <div className="flex h-48 items-center justify-center">
                <Spinner showText text="Loading household overview..." />
            </div>
        );
    }

    const totalAum = accountGroupProfiles.reduce(
        (sum, profile) => sum + parseFloat(profile.accountGroup.aum || '0'),
        0,
    );

    return (
        <div>
            <HouseholdOverviewHeader accountData={accountData} totalAum={totalAum} />
            <PortfolioList accountGroupProfiles={accountGroupProfiles} />
        </div>
    );
};
